// extracted by mini-css-extract-plugin
export default {"container":"saa-z","tab":"taa-z","selected":"uaa-z"};